<p-toast position="bottom-right"></p-toast>
<p-toast key="log" position="center"></p-toast>
<p-confirmDialog appendTo="body" ></p-confirmDialog>

<!--<app-crud-table [crudService]="crudService"-->
<!--                 [transPartKey]="transPartKey" [fieldId]="fieldId" [fieldName]="'title'" [fieldEnabled]="'active'"-->
<!--                 [tableConfig]="tableConfig" [newRecord]="newRecord"-->
<!--                 [(formRecord)]="formRecord" [formConfig]="formConfig"-->
<!--                 [formLoading]="formLoading" [(records)]="records"-->
<!--                 [(selectedRecords)]="selectedRecords" [(dialogFormVisible)]="dialogFormVisible"-->
<!--                 [contextMenuConfig]="contextMenuConfig" [headerButtonConfig]="headerButtonConfig"-->
<!--                 [prepareForCreate]="prepareRecordForCreate" [prepareForClone]="prepareRecordForClone"-->
<!--                 [prepareForEdit]="prepareRecordForEdit"-->
<!--                 [(tableCurrentRequest)]="tableCurrentRequest" [totalRecords]="totalRecords"-->
<!--                 [dialogFormTitle]="dialogFormTitle"-->
<!--&gt;</app-crud-table>-->

<!--<app-cc-form-dialog [transPartKey]="transPartKey"-->
<!--                   [loading]="false" [submitted]="settingsSubmitted"-->
<!--                   [loadingProgressValue]="settingsFormLoadingProgressValue"-->
<!--                   [(dialogFormVisible)]="settingsDialogFormVisible"-->
<!--                   [formConfig]="settingsFormConfig"-->
<!--                   [dialogFormTitle]="('common.edit' | translate)+' '+('page.' + transPartKey + '.settings_name' | translate)"-->
<!--                   [(formRecord)]="settings"-->
<!--                   (onSubmitEvent)="saveSettings()"-->
<!--&gt;</app-cc-form-dialog>-->
<app-crud-table body #crudTable [crudService]="crudService"
                [transPartKey]="transPartKey" [fieldId]="'ids'" [fieldName]="''"
                [tableConfig]="tableConfig" [newRecord]="newRecord" [tableLoading]="tableLoading"
                [(formRecord)]="formRecord" [formConfig]="formConfig"
                [(dialogFormVisible)]="dialogFormVisible" (dialogFormVisibleChange)="onFormShow()"
                [settingsFormLoadingProgressValue]="settingsFormLoadingProgressValue"
                [(selectedRecords)]="selectedRecords" [dialogFormTitle]="dialogFormTitle"
                [contextMenuConfig]="contextMenuConfig" [headerButtonConfig]="headerButtonConfig"
                [(tableCurrentRequest)]="tableCurrentRequest" [(records)]="records" (onSave)="onSaved()"
                [lazyLoadOnInit]="true" [totalRecords]="totalRecords" (onContextMenuShow)="refreshContextMenu()"
                (onClearTableFilter)="clearFilters()" [dialogClass]="'cc-profile-form-dialog'"
                (tableCurrentRequestChange)="tableCurrentRequestChanged()"
                [prepareForCreate]="prepareForCreate" [prepareForClone]="prepareForClone"
                [prepareSelectedIds]="prepareSelectedIds"
>
        <span table-toolbar-left>
              <i class="toolbar-separator fa fa-diamond"></i>
        </span>
        <span table-toolbar-left class="filter-label ml-10-imp">
          {{'page.tools.notify.filter.types' |translate}}
        </span>
        <span table-toolbar-left>
          <p-multiSelect [options]="types" [(ngModel)]="selectedTypes"
                         optionLabel="text" class="profile-type-menu"
                         (onChange)="filterChanged()"></p-multiSelect>
        </span>
</app-crud-table>
